import type { IntlShape } from 'react-intl/src/types';
import { bool, type InferType, object } from 'yup';

import { commonMessages } from '@/messages/common';

export type ConsentFormValues = InferType<ReturnType<typeof schema>>;

export const schema = (formatMessage: IntlShape['formatMessage']) =>
  object({
    conditionsOfSale: bool()
      .oneOf([true], formatMessage(commonMessages.conditionsOfSaleRequired))
      .default(false),
    userAffiliated: bool().default(false),
  });
